import React from 'react';
import { Container, Section } from '../ui/Section';
import { Wordmark } from '../brand/Wordmark';
import { ButtonExternal } from '../ui/Button';
import { Reveal, stagger } from '../motion/Reveal';
import { DoodleScatter } from '../brand/DoodleScatter';
import { brandDescriptor } from '../../data/brandAssets';
import { externalLinks } from '../../data/site';
const pillars = [{
  title: 'Bring In',
  copy: 'Welcome students and help them encounter the Gospel in a genuine Christian community.'
}, {
  title: 'Build Up',
  copy: 'Help students grow in faith, friendship, service, and leadership.'
}, {
  title: 'Send Out',
  copy: 'Equip students to live out their faith and serve on campus and beyond.'
}];
export function Mission() {
  return <Section className="on-dark relative overflow-hidden bg-brand-navy py-16 text-white sm:py-24" labelledBy="mission-heading" data-id="element-161" data-mp="3qoxjonefiuih">
      {/* Navy panel: scatter uses cream, yellow, and light blue only. */}
      <DoodleScatter tone="navy" seed="mission-bring-in" data-id="element-162" data-mp="3k1c3pfjg116u" />
      <Container className="relative" data-id="element-163" data-mp="3k2x1rf4yv29g">
        <Reveal data-id="element-164" data-mp="3ozdoq60fjaky">
          <p className="font-meta text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue" data-id="element-165" data-mp="3p0ygxoz9uhfn">
            Our Mission
          </p>
          <h2 id="mission-heading" className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl" data-id="element-166" data-mp="3u132htf1e2cq">
            Bring in. Build up. Send out.
          </h2>
        </Reveal>

        <ul className="mt-12 grid gap-8 sm:grid-cols-3 sm:gap-10" data-id="element-167" data-mp="bslnmfe2ueuu">
          {pillars.map((pillar, index) => <Reveal key={pillar.title} as="li" delay={stagger(index)} className="border-t-4 border-brand-yellow pt-5" data-id="element-168" data-mp="glesr4dgjp7g" data-mpi={index}>
              <h3 className="font-display text-2xl font-bold text-brand-blue" data-id="element-169" data-mp="pltgsbht3ien">{pillar.title}</h3>
              <p className="mt-2 font-sans text-[16px] leading-relaxed text-white" data-id="element-170" data-mp="uj3bo6nysm9v">{pillar.copy}</p>
            </Reveal>)}
        </ul>

        <Reveal delay={0.1} data-id="element-171" data-mp="2qkx2fvcxeax0">
          <div className="mt-12 flex flex-col gap-8 border-t border-white/25 pt-9 sm:flex-row sm:items-center sm:justify-between" data-id="element-172" data-mp="2mlo92rlssf1z">
            <div data-id="element-173" data-mp="30duky1hx3zvm">
              {/* Supplied artwork on a light brand plate — never recolored. */}
              <Wordmark onDark className="h-8" data-id="element-174" data-mp="2vlaysg55zwf7" />
              <p className="mt-3 font-meta text-[12px] font-medium uppercase tracking-[0.16em] text-brand-blue" data-id="element-175" data-mp="3aaz0vjl66z3z">
                {brandDescriptor}
              </p>
            </div>
            <ButtonExternal href={externalLinks.getConnectedForm} variant="onDark" data-id="element-176" data-mp="35e09h8sw569h">
              Get Connected
            </ButtonExternal>
          </div>
        </Reveal>
      </Container>
    </Section>;
}